import { render, staticRenderFns } from "./MessageCenterPopUpBox.vue?vue&type=template&id=e880b92e&scoped=true"
import script from "./MessageCenterPopUpBox.vue?vue&type=script&lang=js"
export * from "./MessageCenterPopUpBox.vue?vue&type=script&lang=js"
import style0 from "./MessageCenterPopUpBox.vue?vue&type=style&index=0&id=e880b92e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e880b92e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e880b92e')) {
      api.createRecord('e880b92e', component.options)
    } else {
      api.reload('e880b92e', component.options)
    }
    module.hot.accept("./MessageCenterPopUpBox.vue?vue&type=template&id=e880b92e&scoped=true", function () {
      api.rerender('e880b92e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/message/MessageCenterPopUpBox.vue"
export default component.exports